export const MouthSad = () => (
    <div
        style={{
            position: 'absolute',
            top: '62%',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 2,
        }}
    >
        <svg width="28" height="16" viewBox="0 0 28 16">
            <path d="M 3,7 Q 13,0 25,8" fill="none" stroke="#2a2a5c" strokeWidth={4} strokeLinecap="round" />
        </svg>
    </div>
);

export const MouthSmile = () => (
    <div
        style={{
            position: 'absolute',
            top: '55%',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 2,
        }}
    >
        <svg width="28" height="16" viewBox="0 0 28 16">
            <path d="M 3,8 Q 13,16 25,7" fill="none" stroke="#2a2a5c" strokeWidth={4} strokeLinecap="round" />
        </svg>
    </div>
);

interface MouthOpenProps {
    w?: number;
    h?: number;
}

export const MouthOpen = ({ w = 14, h = 14 }: MouthOpenProps) => (
    <div
        style={{
            position: 'absolute',
            top: '55%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: w,
            height: h,
            borderRadius: '50%',
            background: '#2a2a5c',
            zIndex: 2,
        }}
    />
);
